<script>
import DesktopCard from './DesktopCard.svelte';
import { ShadowRoot } from '../../../libraries/ShadowRoot.js';
import { StoreForm } from '../../../register/steps/StoreForm.js';
import { PlansStore } from '../../Plans.store.js';
import { CartParserAddons } from '../../../register/steps/StoreCart.js';
import { SubscriptionsStore } from '../../SubscriptionsStore.js';
import { FormatNumber } from '../../../libraries/formatNumber.js';
import { match_media } from "tripod-styles/src/libraries/match_media";
import MobileCard from './MobileCard.svelte';
import Skeleton from 'tripod-styles/src/components/Skeletons/Skeleton.svelte';
import './plans_styles.scss';
import { Contents } from 'tripod-styles/src/components/ContentsPlatform.store';
import { PlansSizeStore } from '../../PlansSizeStore';


export let tripod_plans;
export let interval;
export let affiliate = {};
export let user = {};
export let membership_selected;
export let onSelectPlan = function(){}; // for internal modules
export let parsedPlans = [];

let metadata = tripod_plans;
let showProducts = tripod_plans?.showProducts ?? true;


let lang = metadata.lang;

let see_more_details = lang.see_more_details ?? "Ver más detalles"
let close_details = lang.close_details ?? "Ver menos detalles"
let select_plan_lang = lang.setPlan ?? "Seleccionar Plan";

match_media("(max-width: 1286px)", ()=>{ // on_match
    select_plan_lang = lang.setPlanAlt ?? "Seleccionar";
}, ()=>{ // on_unmatch
    select_plan_lang = lang.setPlan ?? "Seleccionar Plan";
});

let show_details = false;

$: {
    if($PlansStore){
        membership_selected = $PlansStore.membership_selected;
    }
}





// this will work only in register widget.
let subscriptions = [];
if(($StoreForm?.dataForm?.subscriptions)){
    subscriptions = $StoreForm?.dataForm?.subscriptions ?? [];    
}
let add_trial_end = false;
function SelectPlanInit(){
    let button = this;
    let plan_id = button.dataset.planId;
    let trial_end = button?.dataset?.add_trial_end ?? "no";
    add_trial_end = false;
    if((trial_end) !== "no"){
        add_trial_end = true;
    }
    
    let plan = parsedPlans.find(( plan )=>{
        if(plan.__id__ === plan_id){
            return plan;
        }
    })
    selectPlan(button, plan);
}

function selectPlan(target, plan){

    plan.add_trial_end = add_trial_end;

    let email_marketing = $ShadowRoot.querySelector(`.container-plan-${plan.__id__} .email-marketing-slider-module .input-range-selector`);
    plan.addons = {};

    if(email_marketing !== "" && email_marketing !== null){
        try {
            plan.addons.email_marketing = JSON.parse(atob(email_marketing.value))
        } catch (error) {
            console.error(error);
        }
    }
    
    plan.addons = new CartParserAddons( plan.addons );
    let button = target;
    // will be executed outside any module
    
    tripod_plans.onSelect(plan, interval, plan.interval, button);

    // will be executed in internal modules
    
    onSelectPlan({
        plan: plan, 
        interval: interval,
        add_trial_end: true,
        button: button
    });
}



let current_plan = null;

$: {
    if($PlansStore || $SubscriptionsStore.subscriptions){

        let subscriptions = $SubscriptionsStore.subscriptions;

        parsedPlans = $PlansStore.plans_views.filter(( plan )=>{
            let referralDiscounts = affiliate?.referralDiscounts ?? null;
            let discountPlans = referralDiscounts?.plans ?? null;
            let interval_price;
            let percentOff = 0;
            plan.has_discount = ""; // from switching to anual plan...
            plan.has_special_discount = false; // from referral from coupon
            plan.is_selected = false;
            plan.upgrades = [];
            plan.downgrades = [];
            subscriptions.map(( subscription )=>{       
                let metadata = subscription.metadata;
                let items = subscription.items.data;
                items.map(( item )=>{
                    let subscription_plan = item.plan;
                    let id = item.id_plan;
                    if(plan.__id__ === id && metadata.membership_type === membership_selected){
                        let addons = metadata?.addons ?? null;
                        if(addons !== null){
                            addons = JSON.parse(addons);
                            let addonsObject = {};
                            addons.map((addon)=>{
                                addonsObject[addon.addon_type] = addon;
                            })
                            plan.active_addons = addonsObject;
                        }


                        plan.is_selected = true;
                        plan.interval = subscription_plan.interval;
                        plan.status = subscription.status;
                        current_plan = plan;
                        plan.subscription = subscription;

                    }
                    if(metadata.membership_type === membership_selected){
                        plan.subscription = subscription;
                    }
                })

                

            })

            if(interval !== "month"){
                if(typeof plan[`interval_${interval}_price`] === "undefined" || plan[`interval_${interval}_price`] === ""){
                    interval_price = plan.price_plan;
                    percentOff = 0;
                }else{
                    interval_price = plan[`interval_${interval}_price`];
                    percentOff = (plan.price_plan*100)/plan[`interval_${interval}_price`]-100;
                    percentOff = isNaN(percentOff) === false ? percentOff : 0;
                    percentOff = Number.parseInt(percentOff);
                    plan.has_discount = "has_discount";
                }
            }else{
                interval_price = plan.price_plan;
                percentOff = 0;
            }

            

            plan.interval_current_price = interval_price;

            function onDicountsPlan(discountPlan, is_global = false){
                if(discountPlan.plan === plan.__id__ || is_global === true){
                    let discountPercent = discountPlan?.discountPercent ?? null;
                    
                    if(discountPercent <= 0 || discountPercent === null){
                        return false;
                    }

                    

                    /**
                     * if already has a discount due to a global discount.
                    */
                    if(plan.has_special_discount === true){
                        return false;
                    }
                    

                    plan.interval_current_price = interval_price;
                    interval_price = interval_price - ((discountPlan.discountPercent/100)*interval_price);

                    

                    plan.interval_discount = plan.interval_current_price - interval_price;
                    plan.hasReferralDiscounts = discountPlan.discountPercent;                    
                    plan.has_special_discount = true;
                    
                    

                    if(plan.hasReferralDiscounts <= 0 || plan.hasReferralDiscounts <= false){
                        plan.hasReferralDiscounts = false;
                        plan.has_special_discount = false;
                    }
                }
            }
            plan.interval_selected = interval;

            

            // in case of discounts by referrals

            if(discountPlans  !== null){
                Object.values(discountPlans).map(( dp )=>{
                    onDicountsPlan(dp);
                })
            }else{
                // in case of discounts by tag
                if((plan.discountsPlan ?? null) !== null){
                    onDicountsPlan(plan.discountsPlan);
                }
            }


            if(referralDiscounts !== null){
                try {
                    let global_discount = referralDiscounts?.global_discount ?? null;
                    if(Object.values(global_discount).length !== 0 && global_discount !== null){
                        onDicountsPlan(global_discount, true);
                    }
                } catch (error) {
                    
                }
            }

            plan.hasReferralDiscounts = plan?.hasReferralDiscounts ?? false;
            

            interval_price = Number.parseFloat(Number.parseFloat(interval_price).toFixed(2))

            plan.interval_price = interval_price;
            plan.percentOff = percentOff ?? 0;

            let currency = plan.currency ?? null !== null ? plan.currency : tripod_plans.currency;
            let is_recommended = ((plan.is_recommended ?? "Default") === "Recomendado") ? "recommended" : plan.is_recommended||"";
            let yearly = typeof plan.interval_year_price === "undefined" ? null : plan.interval_year_price;
            plan.currency = currency;
            plan.is_recommended = is_recommended;
            plan.yearly = is_recommended;
            plan.is_available = plan.is_available || "public";

            plan.active = false;


            let same_interval = (plan?.interval ?? null) === interval;
            if(plan.is_selected){
                plan.active = true;
                email_marketing_purchased = true;
                if(!same_interval){
                    plan.active = false;
                }
            }
            

            if(plan.status === "canceled"){
                plan.active = false;
            }
            

            let currentPlan = tripod_plans?.currentPlan ?? null;
            let currentSubscription = tripod_plans?.currentSubscription ?? null;
            
            try {
                if(currentPlan.__id__ !== plan.__id__ && plan.is_selected === false){
                    plan.active = false;
                }else{
                    plan.active = true;
                    email_marketing_purchased = true;
                }
            } catch (error) {
                plan.active = false;
            }

            if(((plan?.interval ?? null) === interval) === false){
                plan.active = false;
            }
            
            /**
             * verify current plan from subscription
            */
            if((currentSubscription?.plan?.id_plan ?? null) !== null){
                if(currentSubscription.plan.id_plan === (plan?.id_plan ?? plan?.__id__) ?? null){
                    plan.active = true;
                }
            }
            
            /**
            * if the interval to year changes set as not active plan.
            */
            if(currentSubscription !== null){
                if(interval !== currentSubscription.prices[0].interval){
                    plan.active = false;
                }
            }

            let forceCurrentPlan = tripod_plans?.forceCurrentPlan ?? false;
            if(forceCurrentPlan !== false){
                if(forceCurrentPlan === plan.__id__){
                    plan.active = true;
                }
            }

            let tags_user = [];
            let userFromCampaign = user?.userFromCampaign ?? user.user_from_campaign ?? "";
            if(userFromCampaign !== ""){
                tags_user.push(userFromCampaign);
            }

            if(typeof user?.more_tags === "string"){
                try {
                    user.more_tags = user.more_tags.trim().split(",");
                } catch (error) {
                    tags_user = [];
                }
            }

            try {
                user.more_tags.forEach((tag)=>{
                    tag = tag.trim();
                    if(tag !== ""){
                        tags_user.push(tag);
                    }
                })
            } catch (error) {
                tags_user = [];
            }

            if(tags_user.length > 0){
                if(tags_user.includes(plan.tag)){
                    return plan;
                }
            }
            if(plan.is_available === "public"){
                return plan;
            }
        })

    }
}

let has_products = false;
let benefits_items = {};
$: {
    if(parsedPlans){
        has_products = false;
        parsedPlans.map((plan)=>{
            if(plan.type === "PRODUCT"){
                has_products = true;
            }
        })

        if(has_products === true){
            parsedPlans.reverse();
        }


        parsedPlans.map((plan)=>{
            Object.values(plan.benefits).map((benefit, key)=>{
                let field = Object.keys(plan.benefits)[key];
                let hidden = benefit.hidden ?? false;

                let name = Contents.search(benefit.name, window.lang_selected)
                if(!hidden){
                    benefits_items[field] = {
                        info_ctn: benefit?.info_ctn ?? null,
                        name: name,
                        code_content: benefit?.code_content ?? null,
                        field: field
                    };
                }
                
            })
            
        })
    }
}
function get_value(benefit){
    if(typeof benefit.alt_value === "string" && benefit.alt_value !== ""){
        return benefit.alt_value;
    }
    return benefit.value;
}


function set_value_benefit(benefit, is_mobile = false){
    if(benefit === null){
        return `<i class="icon-tripod-v-close-circle"></i>`
    }

    let unlimited = benefit.is_unlimited ?? false;
    
    let unit = Contents.set_from_id(benefit.unit);
    let name = `<span class="name-benefit">${benefit.name}</span>`
    let wrap_flex = (name, icon)=> `<span class="is-flex is-align-items-center has-text-left is-gap-10">
        <span class="has-text-left">${icon}</span>
        <span class="has-text-left">${name}</span>
    </span>`;
    if(benefit.type === "string"){
        benefit.value = Contents.search(get_value(benefit), window.lang_selected)
    }

    if(is_mobile){
        if(unlimited){
            return wrap_flex(`${name}: ${lang.unlimited ?? "-"}`, '<i class="icon-tripod-checklist-alt has-text-success"></i>')
        }

        if(benefit.type === "boolean"){
            if(benefit.value === true){
                return wrap_flex(name, '<i class="icon-tripod-checklist-alt has-text-success"></i>')
            }else{
                return null;
            }
        }

        if(benefit.type === "number"){
            if(benefit.value === 0 && benefit.can_be_unlimited){
                return null;
            }
            let value = `${FormatNumber(get_value(benefit))}`;
            if(typeof benefit.alt_value === "string" && benefit.alt_value !== ""){
                value = get_value(benefit);
            }

            return wrap_flex(`${name}: ${value} ${unit}`, '<i class="icon-tripod-checklist-alt has-text-success"></i>');
        }

        if(benefit.type === "string"){
            return wrap_flex(`${name}: ${get_value(benefit)}`, '<i class="icon-tripod-checklist-alt has-text-success"></i>');
        }
    }

    if(unlimited){
        return lang.unlimited ?? "-"
    }

    if(benefit.type === "boolean"){
        if(benefit.value === true){
            return `<i class="icon-tripod-checklist-alt has-text-success"></i>`
        }else{
            return `<i class="icon-tripod-v-close-circle has-text-danger"></i>`
        }
    }

    if(benefit.type === "number"){
        if(benefit.value === 0 && benefit.can_be_unlimited){
            return `<i class="icon-tripod-v-close-circle has-text-danger"></i>`
        }
        if(typeof benefit.alt_value === "string" && benefit.alt_value !== ""){
            let value = `${Contents.search(benefit.alt_value, window.lang_selected, {
                value: benefit.value,
                unit: benefit.unit,
            })}`;
            let unit = Contents.set_from_id(benefit.unit, window.lang_selected);
            
            return `${value} ${unit}`;
        }

        return `${FormatNumber(benefit.value)} ${Contents.set_from_id(benefit.unit, window.lang_selected)}`;
    }

    if(benefit.type === "string"){
        return benefit.value
    }

    // on case of uknown option
    return `<i class="icon-tripod-v-close-circle has-text-danger"></i>`
}

</script>
{#if $PlansStore.plans_views.length <= 0}
    <div class="columns is-multiline pb-alt-4 pt-alt-8">
        <div class="is-hidden-mobile">
            <Skeleton class="column" is_loaded={false} has_manual_dimensions={true} width={"250px"} height={"400px"}>
                <div style="width:250px;height:400px;"></div>
            </Skeleton>
        </div>
        <div class="is-hidden-mobile">
            <Skeleton class="column" is_loaded={false} has_manual_dimensions={true} width={"250px"} height={"400px"}>
                <div style="width:250px;height:400px;"></div>
            </Skeleton>
        </div>
        <div class="is-hidden-mobile">
            <Skeleton class="column" is_loaded={false} has_manual_dimensions={true} width={"250px"} height={"400px"}>
                <div style="width:250px;height:400px;"></div>
            </Skeleton>
        </div>
        <!-- mobile skeleton -->
        <div class="is-hidden-desktop is-hidden-tablet">
            <Skeleton class="column" is_loaded={false} has_manual_dimensions={true} width={"200px"} height={"50px"} count="2" type="table">
                <div style="width:200px;height:50px;"></div>
            </Skeleton>
            <Skeleton class="column" is_loaded={false} has_manual_dimensions={true} width={"200px"} height={"50px"} count="2" type="table">
                <div style="width:200px;height:50px;"></div>
            </Skeleton>
        </div>
    </div>
{/if}
<div class="core-plans plans-count-{parsedPlans.length} is-relative">
    {#if $PlansSizeStore >= 900}
        <DesktopCard 
            SelectPlanInit={SelectPlanInit}
            set_value_benefit={set_value_benefit}
            bind:parsedPlans={parsedPlans}
            bind:benefits_items={benefits_items}
            bind:has_products={has_products}
            bind:metadata={metadata}
            bind:interval={interval}
            bind:select_plan_lang={select_plan_lang}
            bind:lang={lang}
            bind:show_details={show_details}
            bind:see_more_details={see_more_details}
            bind:close_details={close_details}
        />
    {/if}
    {#if $PlansSizeStore < 900}
        <MobileCard 
            SelectPlanInit={SelectPlanInit}
            set_value_benefit={set_value_benefit}
            bind:parsedPlans={parsedPlans}
            bind:benefits_items={benefits_items}
            bind:has_products={has_products}
            bind:metadata={metadata}
            bind:interval={interval}
            bind:select_plan_lang={select_plan_lang}
            bind:lang={lang}
            bind:show_details={show_details}
            bind:see_more_details={see_more_details}
            bind:close_details={close_details}
        />
    {/if}
</div>